import React, { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { DatosProvider, useDatos } from './contexts/DatosContext';
import { Estructura } from './components/layout/Estructura';
import { Bienvenida } from './components/Bienvenida';
import { Inicio } from './pages/Inicio';
import { NuevaClase } from './pages/NuevaClase';
import { MisClases } from './pages/MisClases';
import { Biblioteca } from './pages/Biblioteca';
import { EjerciciosPersonalizados } from './pages/EjerciciosPersonalizados';
import { Ayuda } from './pages/Ayuda';
import { Impresion } from './pages/Impresion';
function Contenido() {
  const {
    cargando,
    aceptado,
    aceptar
  } = useDatos();
  if (cargando) {
    return <div className="flex min-h-screen w-full items-center justify-center bg-lienzo px-4" role="status" aria-live="polite" data-id="element-0" data-mp="2wj8cjlweui34">
        <p className="text-sm font-semibold text-tinta-sec" data-id="element-1" data-mp="23vcmh01cjofb">Cargando tus datos guardados…</p>
      </div>;
  }
  if (!aceptado) {
    return <Bienvenida onAceptar={aceptar} data-id="element-2" data-mp="3iiwasc8k4vxf" />;
  }
  return <Routes data-id="element-3" data-mp="3mlj8gtrwtb2j">
      <Route path="/imprimir/:id" element={<Impresion data-id="element-5" data-mp="3mk84asujy1aw" />} data-id="element-4" data-mp="3mlatmwc87vop" />
      <Route path="*" element={<Estructura data-id="element-7" data-mp="3rbzmaezn6ypf">
            <Routes data-id="element-8" data-mp="3rdkgu4lyihna">
              <Route path="/" element={<Inicio data-id="element-10" data-mp="5yi8qe3h5da" />} data-id="element-9" data-mp="3recerm310rgq" />
              <Route path="/nueva" element={<NuevaClase data-id="element-12" data-mp="5ggje8nxyxz" />} data-id="element-11" data-mp="680tswt8a8y" />
              <Route path="/nueva/:id" element={<NuevaClase data-id="element-14" data-mp="2zlv66six0xu0" />} data-id="element-13" data-mp="7stte3h7l4p" />
              <Route path="/clases" element={<MisClases data-id="element-16" data-mp="2zng2onosiqui" />} data-id="element-15" data-mp="2zmo6bandcp36" />
              <Route path="/biblioteca" element={<Biblioteca data-id="element-18" data-mp="33n6yx6x35z6f" />} data-id="element-17" data-mp="33m5bs42spm8c" />
              <Route path="/personalizados" element={<EjerciciosPersonalizados data-id="element-20" data-mp="38li7zffk45nl" />} data-id="element-19" data-mp="33oi1x4ipj2wh" />
              <Route path="/ayuda" element={<Ayuda data-id="element-22" data-mp="3dkl42adk71jf" />} data-id="element-21" data-mp="38nup5qdhqbzl" />
              <Route path="*" element={<Navigate to="/" replace data-id="element-24" data-mp="3dmfolnkx4rmz" />} data-id="element-23" data-mp="3dl4k1ljnffut" />
            </Routes>
          </Estructura>} data-id="element-6" data-mp="3mjg9vlcoy9m7" />
    </Routes>;
}
export function App() {
  useEffect(() => {
    let meta = document.querySelector<HTMLMetaElement>('meta[name="robots"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'robots';
      document.head.appendChild(meta);
    }
    meta.content = 'noindex,nofollow';
    document.title = 'Planificador Pro de Clases de Telas';
  }, []);
  return <DatosProvider data-id="element-25" data-mp="d3cr1enu48a8">
      <BrowserRouter data-id="element-26" data-mp="d2l9v8uzid3h">
        <Contenido data-id="element-27" data-mp="85l1usekr09q" />
      </BrowserRouter>
    </DatosProvider>;
}